import { useScroll } from '@vueuse/core';

export const useWwwScroll = () => {
  const toTopOfWindow = () => {
    const { y } = useScroll(window, { behavior: 'smooth' });
    y.value = 0;
  };

  return {
    toTopOfWindow,
  };
};
